<template>
  <div>
    <el-menu
      :unique-opened="true"
      :default-active="String(defaultActive)"
      :mode="mode"
      :ellipsis="false"
      style="height: 100%"
    >
      <template v-for="(menuItem, itemIndex) in menu">
        <!--一级菜单含子菜单-->
        <el-sub-menu
          :key="itemIndex"
          :index="`${itemIndex}`"
          v-if="menuItem.children"
        >
          <template #title>
            <!-- 菜单是外链接的 -->
            <a
              :href="menuItem.path"
              v-if="
                menuItem.path &&
                (menuItem.path.indexOf('http://') > -1 ||
                  menuItem.path.indexOf('https://') > -1)
              "
              target="_blank"
              class="withtText"
            >
              <div class="withtText">
                <span>{{ menuItem.name }}</span>
              </div>
            </a>
            <router-link
              :to="menuItem.path"
              v-else-if="menuItem.path"
              :target="openNewTab === 'T' ? '_blank' : '_self'"
            >
              <div class="withtText">
                <span>{{ menuItem.name }}</span>
              </div>
            </router-link>
            <div v-else class="level2MenuTitle">
              <!-- <div
                    class="mainMenuImg"
                    :class="'png_' + menuItem.perm"
                  ></div> -->
              <span>{{ menuItem.name }}</span>
            </div>
          </template>

          <template v-for="(menuSecond, secondIndex) in menuItem.children">
            <!--二级菜单含子菜单-->
            <el-sub-menu
              :key="secondIndex"
              :index="`${itemIndex}-${secondIndex}`"
              v-if="menuSecond.children && menuSecond.children.length"
              class="secondMenu"
            >
              <!-- 菜单是外链接的 -->
              <a
                :href="menuSecond.path"
                v-if="
                  menuSecond.path &&
                  (menuSecond.path.indexOf('http://') > -1 ||
                    menuSecond.path.indexOf('https://') > -1)
                "
                target="_blank"
                class="withtText"
              >
                <span>
                  {{ menuSecond.name }}
                </span>
              </a>
              <router-link
                :to="menuSecond.path"
                v-else-if="menuSecond.path"
                :target="openNewTab === 'T' ? '_blank' : '_self'"
              >
                <span>
                  {{ menuSecond.name }}
                </span>
              </router-link>

              <template #title>
                <div v-if="!menuSecond.path" style="display: flex">
                  <span>{{ menuSecond.name }}</span>
                </div>
              </template>
              <!--三级菜单-->
              <template
                v-for="(menuThird, thirdIndex) in menuSecond.children"
                :key="thirdIndex"
              >
                <!-- 菜单是外链接的 -->
                <a
                  :href="menuThird.path"
                  v-if="
                    menuThird.path &&
                    (menuThird.path.indexOf('http://') > -1 ||
                      menuThird.path.indexOf('https://') > -1)
                  "
                  target="_blank"
                  class="withtText"
                >
                  <el-menu-item
                    :index="`${itemIndex}-${secondIndex}-${thirdIndex}`"
                    class="thirdMenu"
                  >
                    {{ menuThird.name }}444
                  </el-menu-item>
                </a>
                <router-link
                  :to="menuThird.path"
                  v-else-if="menuThird.path"
                  :target="openNewTab === 'T' ? '_blank' : '_self'"
                >
                  <el-menu-item
                    :index="`${itemIndex}-${secondIndex}-${thirdIndex}`"
                    class="thirdMenu"
                    style="display: flex"
                  >
                    <span>{{ menuThird.name }}</span>
                  </el-menu-item>
                </router-link>
                <div v-if="!menuThird.path">
                  <el-menu-item
                    :index="`${itemIndex}-${secondIndex}-${thirdIndex}`"
                    class="thirdMenu"
                    >{{ menuThird.name }}666</el-menu-item
                  >
                </div>
              </template>
            </el-sub-menu>
            <!--二级菜单不含子菜单-->
            <div
              v-if="!menuSecond.children || !menuSecond.children.length"
              :key="secondIndex"
              class="secondMenu"
            >
              <!-- 菜单是外链接的 -->
              <a
                :href="menuSecond.path"
                v-if="
                  menuSecond.path &&
                  (menuSecond.path.indexOf('http://') > -1 ||
                    menuSecond.path.indexOf('https://') > -1)
                "
                target="_blank"
                class="withtText"
              >
                <el-menu-item
                  :index="`${itemIndex}-${secondIndex}`"
                  style="display: flex"
                >
                  <span>{{ menuSecond.name }}</span>
                </el-menu-item>
              </a>
              <router-link
                :to="menuSecond.path"
                v-else-if="menuSecond.path"
                :target="openNewTab === 'T' ? '_blank' : '_self'"
              >
                <el-menu-item
                  :index="`${itemIndex}-${secondIndex}`"
                  style="display: flex"
                >
                  <span>{{ menuSecond.name }}</span>
                </el-menu-item>
              </router-link>
              <el-menu-item
                :index="`${itemIndex}-${secondIndex}`"
                v-if="!menuSecond.path"
              >
                <span>{{ menuSecond.name }}</span>
              </el-menu-item>
            </div>
          </template>
        </el-sub-menu>
        <!--一级菜单不含子菜单-->
        <div v-if="!menuItem.children" :key="itemIndex">
          <!-- 菜单是外链接的 -->
          <a
            :href="menuItem.path"
            v-if="
              menuItem.path &&
              (menuItem.path.indexOf('http://') > -1 ||
                menuItem.path.indexOf('https://') > -1)
            "
            target="_blank"
            class="withtText"
          >
            <el-menu-item :index="`${itemIndex}`">
              <template #title>
                <span>{{ menuItem.name }}</span>
              </template>
            </el-menu-item>
          </a>
          <router-link
            :to="menuItem.path"
            v-else-if="menuItem.path"
            :target="openNewTab === 'T' ? '_blank' : '_self'"
          >
            <el-menu-item :index="`${itemIndex}`">
              <!-- <div
                    class="mainMenuImg"
                    :class="'png_' + menuItem.icon"
                  ></div> -->
              <template #title>
                <span> {{ menuItem.name }}</span>
              </template>
            </el-menu-item>
          </router-link>
          <router-link to="/OTA">
            <el-menu-item :index="`${itemIndex}`" v-if="!menuItem.path">
              <template #title>
                <span>{{ menuItem.name }}</span>
              </template>
            </el-menu-item>
          </router-link>
        </div>
      </template>
    </el-menu>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "LeftMenu",
  props: {
    mode: String,
  },
  computed: {
    ...mapState({
      openNewTab: (state) => state.common.openNewTab,
    }),
  },
  watch: {
    $route(){
      this.getMenu();
    }
  },
  data() {
    return {
      menu: [],
      isCollapse: false,
      defaultActive: 0,
      isShowLeft: true, //判断竖的菜单显示还是折叠
    };
  },
  beforeMount() {
    this.getMenu();
  },
  mounted() {
    // this.showLeftMenu()
  },
  methods: {
    getMenu(){
      let menu = window.localStorage.getItem("menu");
      if (menu) {
        this.menu = JSON.parse(menu);
        if (this.mode != "horizontal") {
          // 左侧菜单
          if (
            [
              "/shop/shopManage",
              '/config/serviceFee/receiveAccount',
              '/config/serviceFee/rechargeManager',
              '/config/serviceFee/costBill',
              "/roomtype_manage",
              "/housekeeper_distribution",
              "/room_transfer",
              "/sorting",
              "/system/common/users/index",
              "/system/common/roles",
              "/system/common/dictMng",
              "/system/advance/systemParams",
              "/system/dataPush",
              "/system/pushDataLog",
              "/config/employee",
              "/system/auditConfig",
              "/system/log/operateLog",
              "/OTA",
            ].includes(this.$route.path)
          ) {
            // 设置
            this.menu = this.menu.find((e) => e.perm == "setting").children;
          }
          if (
            [
              "/equip/doorLock",
              "/equip/doorBell",
              "/gateLockLog",
              '/firmwareManager',
              '/issuedLog',
              '/equip/whiteList',
              '/gateBellLog',
            ].includes(this.$route.path)
          ) {
            // 设备
            this.menu = this.menu.find((e) => e.perm == "equipment").children;
          }
        } else {
          // 顶部菜单
          this.menu = this.menu.map((e) => {
            if (e.perm == "statistical" && e.children && e.children.length) {
              return {
                ...e,
                path: e.children[0].path,
                children: null,
              };
            }
            if (e.perm == "setting") {
              e.path = e.children[0].children[0].path;
              e.children = e.children[0].children[0].children;
            }
            if (e.perm == "equipment") {
              e.path = e.children[0].path;
              e.children = e.children[0].children;
            }
            return e;
          });
        }
      } else {
        this.menu = [];
      }
      this.returnMenu(this.menu);
      this.menu = this.menu.filter((item) => item.id != 114 && item.id != 115); // 个人中心和运维app权限去除
    },
    // 构建菜单
    returnMenu(menu = [], menuIndex = "") {
      for (let i = 0; i < menu.length; i++) {
        let showMenu = this.hasMenuPerms(menu[i]);
        if (!showMenu) {
          menu.splice(i, 1);
          i--;
          continue;
        }

        menu[i].menuIndex = menuIndex + i;
        if (this.$route.meta.perm === menu[i].perm) {
          this.defaultActive = menu[i].menuIndex;
        }
        // type 为 1 代表菜单，为 2 代表权限，权限删掉
        if (menu[i].children && menu[i].children.length) {
          let hasPerm = false;
          menu[i].children.forEach((item) => {
            if (item.type == 2 && !hasPerm) hasPerm = true;
          });
          if (hasPerm) {
            // 只要children包含权限的，舍弃其下的子菜单
            menu[i].children = null;
            continue;
          }

          this.returnMenu(menu[i].children, menu[i].menuIndex + "-");
        } else {
          menu[i].children = null;
        }
      }
    },
    // 是否有菜单查询权限
    hasMenuPerms(menu) {
      // id 为 1 是统计看板
      if (["1", "2001", "2002", "21", "4", "13", "25", "27"].includes(menu.id)) {
        return true;
      }
      if (this.mode == "horizontal") {
        if (menu.id == 4 || menu.id == 21 || menu.id == 13) {
          return false;
        }
      }
      // 有子菜单的，这个菜单一定显示，没有子菜单，有查询权限的这个菜单一定显示
      if (menu.children && menu.children.length) {
        let hasMenu = false;
        let hasSearchPerm = false;
        menu.children.forEach((item) => {
          if (item.type == 1 && !hasMenu) hasMenu = true;
          if (item.type == 2 && item.perm == "query" && !hasSearchPerm)
            hasSearchPerm = true;
        });
        return hasMenu || hasSearchPerm;
      }

      return false;
    },
    hideLeftMenu() {
      if (!this.isShowLeft) {
        return;
      }

      // $("#openMenu").removeClass("showLeft");
      $("#hiddenMenu").addClass("showLeft");
      $("#page-wrapper").addClass("withOutLeftMenu");
    },
    showLeftMenu() {
      setTimeout(() => {
        this.isShowLeft = true;
      }, 500);
      $("#hiddenMenu").removeClass("showLeft");
      // $("#openMenu").addClass("showLeft");
      $("#page-wrapper").removeClass("withOutLeftMenu");
    },
  },
};
</script>
<style lang="less" scoped>
// .left {
//   // transform: translateX(-150px);
//   transition: 0.5s all ease;
// }
// .showLeft {
//   transform: translateX(0) !important;
// }
// .left {
//   background-color: rgba(22, 33, 55, 1);
//   .appTitle {
//     text-align: center;
//     height: 100px;
//     line-height: 100px;
//   }
//   .side-menu {
//     width: 100%;
//     height: calc(~"100vh - 100px");
//     overflow-y: auto;
//     padding-left: 20px;
//     &::-webkit-scrollbar {
//       width: 0 !important;
//     }
//     ul {
//       width: 101%;
//     }
//     .el-menu {
//       background-color: rgba(22, 33, 55, 1);
//       .el-menu-item {
//         color: #fff;
//         background-color: rgba(22, 33, 55, 1);
//         padding: 0 !important;
//         height: 47px;
//         &:hover {
//           background-color: transparent;
//         }
//         &.is-active {
//           color: #00c0c0 !important;
//         }
//       }
//       /deep/ .el-sub-menu {
//         .el-sub-menu__title {
//           padding: 0 !important;
//           &:hover {
//             background-color: transparent;
//           }
//         }
//         .el-menu {
//           background-color: rgba(22, 33, 55, 1);
//           .el-menu-item {
//             min-width: 100%;
//           }
//         }
//       }
//     }

//     .menu-ctrl {
//       padding: 9px;
//       text-align: center;
//     }
//     .el-menu-vertical {
//       overflow-y: auto;
//       .icon-span {
//         padding-right: 5px;
//       }
//     }
//     ::-webkit-scrollbar {
//       width: 0 !important;
//       border-radius: 9px;
//       height: 10px;
//     }

//     .el-menu-item.thirdMenu {
//       background: rgba(5, 19, 51, 0.9);
//       font-size: 14px;
//       padding-left: 60px !important;
//     }
//     // 二级菜单层级
//     .secondMenu {
//       .el-menu-item {
//         color: #7d8eb0;
//       }
//     }
//     .level2MenuTitle span {
//       color: #fff;
//     }
//   }
// }
// .left-hidden {
//   position: absolute;
//   z-index: 1000;
//   top: calc(~"50vh - (14vh + 2px)/2");
//   /*transform: translateY(-50%);*/
//   width: 15px;
//   height: calc(~"14vh + 2px");
//   cursor: pointer;
//   text-align: right;
//   transition: 0.5s all ease;
//   transform: translateX(-300px);
// }
// .right-border {
//   position: absolute;
//   right: 0px;
// }
// .menu-border-img-top {
//   position: absolute;
//   top: 0;
//   left: -234px;
//   width: 252px;
//   height: 22px;
//   background: url("../../assets/img/stars/menu-bg-img-top.png") 100% 100%
//     no-repeat;
// }
// .border3 {
//   height: calc(~"43vh - 30px");
// }
// .border2 {
//   height: calc(~"43vh - 1px");
// }
// .open {
//   height: calc(~"14vh + 2px");
//   cursor: pointer;
// }
// .collapseIcon {
//   padding-top: 5px;
//   margin-right: -18px;
//   width: 18px;
//   background: #333;
//   color: white;
//   height: 60px;
//   line-height: 60px;
//   border-bottom-right-radius: 5px;
//   border-top-right-radius: 5px;
// }
// .withtText {
//   color: #fff;
// }
.el-sub-menu {
  .el-menu-item {
    min-width: initial;
  }
}
</style>

<style lang="less">
// @import url("./css/LeftMenu.less");
.el-menu--horizontal {
  border-bottom: none !important;
}
.el-menu {
  border-right: none !important;
}
</style>
